import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19a51cb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = {
  key: 0,
  class: "nav-icon"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加子标签页", -1))

import { computed } from 'vue'
import { useAcl } from 'vue-simple-acl'
import { NTooltip, NEllipsis } from 'naive-ui'
import aclRules from '@teams/common/acl/aclRules'
import Icon from '@teams/common/components/icon'


export default /*#__PURE__*/_defineComponent({
  __name: 'nav',
  props: {
    icon: null,
    name: null,
    disabled: { type: Boolean },
    onAddSubNav: null
  },
  setup(__props: any) {



const acl = useAcl()
const addNavVisible = computed(() => acl.can(aclRules.navigation_add_tag))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.icon), 1))
      : _createCommentVNode("", true),
    (__props.name)
      ? (_openBlock(), _createBlock(_unref(NEllipsis), {
          key: 1,
          class: "nav-name",
          tooltip: { placement: 'bottom' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.name), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(addNavVisible))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "nav-icon__plus",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onAddSubNav && __props.onAddSubNav(...args)))
        }, [
          _createVNode(_unref(NTooltip), {
            trigger: "hover",
            placement: "bottom",
            style: {"max-width":"220px","padding":"8px 12px"}
          }, {
            trigger: _withCtx(() => [
              _createVNode(_unref(Icon), {
                name: "add",
                fill: "transparent"
              })
            ]),
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})